export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      5249.160997732426,
    ],
    button_spin: [
      7000,
      869.2970521541952,
    ],
    end_free_spin: [
      9000,
      2967.8004535147393,
    ],
    free_bet_big_win: [
      13000,
      1377.2335600907031,
    ],
    free_bet_mega_win: [
      16000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      20000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      22000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      25000,
      40906.30385487529,
    ],
    free_spin_music: [
      67000,
      51282.72108843538,
    ],
    free_spin_popup: [
      120000,
      2718.185941043089,
    ],
    free_spin_start: [
      124000,
      7489.88662131518,
    ],
    inside_buttons: [
      133000,
      265.57823129252256,
    ],
    main_ambient: [
      135000,
      90402.53968253967,
    ],
    main_music: [
      227000,
      119619.04761904759,
    ],
    mega_win: [
      348000,
      5278.185941043092,
    ],
    outside_buttons: [
      355000,
      55.14739229022325,
    ],
    reel_spin: [
      357000,
      989.7505668934059,
    ],
    reel_stop_01: [
      359000,
      155.2834467120192,
    ],
    reel_stop_02: [
      361000,
      166.8934240362887,
    ],
    reel_stop_03: [
      363000,
      120.45351473921073,
    ],
    reel_stop_04: [
      365000,
      120.45351473921073,
    ],
    reel_stop_05: [
      367000,
      123.3560090702781,
    ],
    regular_win: [
      369000,
      918.6394557823405,
    ],
    scatter_stop: [
      371000,
      927.3469387754858,
    ],
    tap_to_play: [
      373000,
      4587.392290249454,
    ],
    ultra_win: [
      379000,
      3583.1292517006545,
    ],
    wild_stop: [
      384000,
      1461.4058956915983,
    ],
  },
}
